import {
    PortfolioSummaryConfigurationState,
    initialPortfolioSummaryConfiguration,
} from 'widgets/portfolioSummary/store/instances/configuration/PortfolioSummaryConfigurationState';
import {
    PortfolioSummaryComponentState,
    initialPortfolioSummaryComponentState,
} from 'widgets/portfolioSummary/store/instances/component/PortfolioSummaryComponentState';
import { WidgetWithComponentState } from 'widgets/store/component/WidgetWithComponentState';
import { WidgetWithConfigState } from 'widgets/store/configuration/WidgetWithConfigState';

export type PortfolioSummaryWidgetState =
    WidgetWithConfigState<PortfolioSummaryConfigurationState> &
        WidgetWithComponentState<PortfolioSummaryComponentState>;

export interface PortfolioSummaryWidgetsState {
    [widgetId: string]: PortfolioSummaryWidgetState;
}

export const initialPortfolioSummaryWidgetState: PortfolioSummaryWidgetState = {
    component: initialPortfolioSummaryComponentState,
    config: initialPortfolioSummaryConfiguration,
};

export const initialPortfolioSummaryWidgetsState: PortfolioSummaryWidgetsState =
    {};
